// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { useState, useCallback } from "react";

const useInlineNotification = (autoHideDuration = 4000) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback(
    (message, type = "success") => {
      setNotification({ message, type });

      if (autoHideDuration > 0) {
        setTimeout(() => {
          setNotification(null);
        }, autoHideDuration);
      }
    },
    [autoHideDuration],
  );

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  const showSuccess = useCallback(
    (message) => {
      showNotification(message, "success");
    },
    [showNotification],
  );

  const showError = useCallback(
    (message) => {
      showNotification(message, "error");
    },
    [showNotification],
  );

  const showWarning = useCallback(
    (message) => {
      showNotification(message, "warning");
    },
    [showNotification],
  );

  const showInfo = useCallback(
    (message) => {
      showNotification(message, "info");
    },
    [showNotification],
  );

  return {
    notification,
    showNotification,
    hideNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};

export default useInlineNotification;
